import React, { useState, useEffect } from 'react';
import { Alert, Button, Box } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import WarningIcon from '@mui/icons-material/Warning';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../../services/firebase';
import { useTranslation } from 'react-i18next';

/**
 * 이메일 인증 상태 표시 컴포넌트
 */
const EmailVerificationStatus = ({ 
  user, 
  onResendVerification, 
  isResending = false 
}) => {
  const { t } = useTranslation();
  const [loginMethod, setLoginMethod] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkLoginMethod = async () => {
      if (!user) {
        setLoading(false);
        return;
      }

      try {
        const userRef = doc(db, 'users', user.uid);
        const userSnap = await getDoc(userRef);
        
        if (userSnap.exists()) {
          const userData = userSnap.data();
          setLoginMethod(userData.loginMethod);
        }
      } catch (error) {
        console.error('로그인 방식 확인 실패:', error);
      } finally {
        setLoading(false);
      }
    };

    checkLoginMethod();
  }, [user]);

  if (!user || loading) return null;

  // OAuth 로그인 사용자는 이메일 인증 상태를 표시하지 않음
  if (loginMethod && ['kakao', 'google', 'naver'].includes(loginMethod)) {
    return null;
  }

  // 이메일 로그인 사용자만 인증 상태 표시
  if (loginMethod !== 'email') {
    return null;
  }

  const isVerified = user.emailVerified;

  // 이미 인증된 사용자에게는 메시지를 표시하지 않음
  if (isVerified) {
    return null;
  }

  return (
    <Alert 
      severity="warning"
      icon={<WarningIcon />}
      sx={{ 
        mb: 2,
        '& .MuiAlert-message': {
          width: '100%'
        }
      }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
        <Box>
            <span>⚠️ {t('emailVerification.warning')}</span>
        </Box>
        
          <Button
            size="small"
            variant="outlined"
            onClick={onResendVerification}
            disabled={isResending}
            sx={{ 
              ml: 2,
              minWidth: 'auto',
              whiteSpace: 'nowrap'
            }}
          >
            {isResending ? t('emailVerification.resending') : t('emailVerification.resendButton')}
          </Button>
      </Box>
    </Alert>
  );
};

export default EmailVerificationStatus; 